import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Card, Statistic, Button, Tooltip, Tag, Row,Col } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

class PendingSummary extends Component {

    constructor(props) {
        super(props);
        this.store = props.store;
    }


    generateInvoice = async () => {
        await this.store.generateInvoice();
    }

    renderInvoiceButton = () => {

        if (!this.store.canGenerate) {
            return (
                <Tag color="red">Either errors or no more records to settle</Tag>
            )
        }

        if (this.store.canGenerate && !this.store.isLoading) {
            return (
                <Tooltip title="Generate Invoices for each of the distinct buckets">
                    <Button onClick={() => this.generateInvoice()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Generate Invoice</Button>
                </Tooltip>
            )
        }
    }

    render() {

        const rowLabel = `${this.store.collectionType} Invoices`;
        return (
            <Card>
                <Row gutter={16}>
                    <Col span={8}>
                        <Statistic title={rowLabel.toUpperCase()} value={this.store.rowCount} />
                    </Col>
                    <Col span={8}>
                        <Statistic title="Total IC" value={this.store.totalIcPayable} />
                    </Col>
                    <Col span={8} style={{textAlign:"right"}}>
                        {this.renderInvoiceButton()}
                    </Col>
                </Row>
            </Card>

        )
    }
}

export default observer(PendingSummary);